export enum TruckSmokingPreference {
  Unknown = 0,
  NonSmoking = 1,
  Smoking = 2
}
export const TruckSmokingPreferenceMapping: Record<
  TruckSmokingPreference,
  string
> = {
  [TruckSmokingPreference.Unknown]: 'Unknown',
  [TruckSmokingPreference.NonSmoking]: 'Non-Smoking',
  [TruckSmokingPreference.Smoking]: 'Smoking'
};
